/**
 * @see https://stackoverflow.com/a/58436959
 */
type Join<K, P> = K extends string | number
  ? P extends string | number
    ? `${K}${'' extends P ? '' : '.'}${P}`
    : never
  : never;

/**
 * @see https://stackoverflow.com/a/58436959
 */
type Prev = [
  never,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  ...0[],
];

/**
 * Gets union of all property keys in object type using path (dot.) notation
 * @see https://stackoverflow.com/a/58436959
 * @example
 * type NestedObjectType = {
 * 	a: string;
 * 	b: string;
 * 	nest: {
 *   c: string;
 *	};
 *	otherNest: {
 *   c: string;
 * 	};
 * };
 *
 * type NestedObjectPaths = Paths<NestedObjectType>;
 *
 * // type NestedObjectPaths = "a" | "b" | "nest" | "otherNest" | "nest.c" | "otherNest.c"
 */
export type Paths<T, D extends number = 10> = [D] extends [never]
  ? never
  : T extends Record<string, unknown>
    ? {
        [K in keyof T]-?: K extends string | number
          ? `${K}` | Join<K, Paths<T[K], Prev[D]>>
          : never;
      }[keyof T]
    : '';
